"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageDomain = exports.projectKeys = exports.search = exports.googleMapURL = exports.api = exports.default = void 0;

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cfg = {
  api: {
    baseUrl: '/api',
    searchUrlTemplate: function searchUrlTemplate(queryOptions) {
      var _queryOptions$languag = queryOptions.language,
          language = _queryOptions$languag === void 0 ? 'de' : _queryOptions$languag,
          _queryOptions$query = queryOptions.query,
          query = _queryOptions$query === void 0 ? '' : _queryOptions$query,
          _queryOptions$filters = queryOptions.filters,
          filters = _queryOptions$filters === void 0 ? {} : _queryOptions$filters,
          _queryOptions$preFilt = queryOptions.preFilters,
          preFilters = _queryOptions$preFilt === void 0 ? {} : _queryOptions$preFilt,
          _queryOptions$size = queryOptions.size,
          size = _queryOptions$size === void 0 ? 0 : _queryOptions$size,
          _queryOptions$offset = queryOptions.offset,
          offset = _queryOptions$offset === void 0 ? 0 : _queryOptions$offset,
          _queryOptions$lon = queryOptions.lon,
          lon = _queryOptions$lon === void 0 ? undefined : _queryOptions$lon,
          _queryOptions$lat = queryOptions.lat,
          lat = _queryOptions$lat === void 0 ? undefined : _queryOptions$lat;
      var params = {};

      if (query) {
        params.q = query;
      }

      if (lon && lat) {
        params.lon = lon;
        params.lat = lat;
      }

      if (size) {
        params.size = size;
      }

      if (offset) {
        params.offset = offset;
      }

      Object.keys(filters).forEach(function (filterKey) {
        filters[filterKey].reduce(function (filter, filterValue) {
          if (!filter[filterValue.parameterName]) filter[filterValue.parameterName] = [];
          filter[filterValue.parameterName].push(filterValue.value);
          return filter;
        }, params);
      });
      Object.keys(preFilters).forEach(function (key) {
        return params["query.".concat(key)] = preFilters[key];
      });
      return "/api/".concat(language, "/farms?").concat(_queryString.default.stringify(params));
    },
    searchSuggestionsUrlTemplate: function searchSuggestionsUrlTemplate(queryOptions) {
      var _queryOptions$languag2 = queryOptions.language,
          language = _queryOptions$languag2 === void 0 ? 'de' : _queryOptions$languag2,
          _queryOptions$query2 = queryOptions.query,
          query = _queryOptions$query2 === void 0 ? '' : _queryOptions$query2,
          _queryOptions$size2 = queryOptions.size,
          size = _queryOptions$size2 === void 0 ? 0 : _queryOptions$size2,
          _queryOptions$preFilt2 = queryOptions.preFilters,
          preFilters = _queryOptions$preFilt2 === void 0 ? {} : _queryOptions$preFilt2,
          _queryOptions$filters2 = queryOptions.filters,
          filters = _queryOptions$filters2 === void 0 ? {} : _queryOptions$filters2;
      var params = {};

      if (query) {
        params.q = queryOptions.query;
      }

      if (size) {
        params.size = size;
      }

      Object.keys(filters).forEach(function (filterKey) {
        filters[filterKey].reduce(function (filter, filterValue) {
          if (!filter[filterValue.parameterName]) filter[filterValue.parameterName] = [];
          filter[filterValue.parameterName].push(filterValue.value);
          return filter;
        }, params);
      });
      Object.keys(preFilters).forEach(function (key) {
        return params["query.".concat(key)] = preFilters[key];
      });
      return "/api/".concat(language, "/suggest/farms?").concat(_queryString.default.stringify(params));
    },
    cantonApiUrlTemplate: function cantonApiUrlTemplate(lang) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var params = {};
      Object.keys(query).forEach(function (key) {
        return params["query.".concat(key)] = query[key];
      });
      return "/api/".concat(lang, "/filter/cantons?").concat(_queryString.default.stringify(params));
    },
    lgwProductApiUrlTemplate: function lgwProductApiUrlTemplate(lang) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var params = {};
      Object.keys(query).forEach(function (key) {
        return params["query.".concat(key)] = query[key];
      });
      return "/api/".concat(lang, "/filter/lgwproducts?").concat(_queryString.default.stringify(params));
    },
    lgwDeliveryTypeApiUrlTemplate: function lgwDeliveryTypeApiUrlTemplate(lang) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var params = {};
      Object.keys(query).forEach(function (key) {
        return params["query.".concat(key)] = query[key];
      });
      return "/api/".concat(lang, "/filter/lgwdeliverytype?").concat(_queryString.default.stringify(params));
    },
    brunchCantonApiUrlTemplate: function brunchCantonApiUrlTemplate(lang) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var params = {};
      Object.keys(query).forEach(function (key) {
        return params["query.".concat(key)] = query[key];
      });
      return "/api/".concat(lang, "/filter/brunch-cantons?").concat(_queryString.default.stringify(params));
    },
    productiontypesApiUrlTemplate: function productiontypesApiUrlTemplate(lang, query) {
      var params = {};
      Object.keys(query).forEach(function (key) {
        return params["query.".concat(key)] = query[key];
      });
      return "/api/".concat(lang, "/filter/productiontypes?").concat(_queryString.default.stringify(params));
    },
    projectApiUrlTemplate: function projectApiUrlTemplate(lang, query) {
      var params = {};
      Object.keys(query).forEach(function (key) {
        return params["query.".concat(key)] = query[key];
      });
      return "/api/".concat(lang, "/filter/projects?").concat(_queryString.default.stringify(params));
    },
    soldoutApiUrlTemplate: function soldoutApiUrlTemplate(lang, query) {
      var params = {};
      Object.keys(query).forEach(function (key) {
        return params["query.".concat(key)] = query[key];
      });
      return "/api/".concat(lang, "/filter/soldout?").concat(_queryString.default.stringify(params));
    },
    programsApiUrlTemplate: function programsApiUrlTemplate(lang, query) {
      var params = {};
      Object.keys(query).forEach(function (key) {
        return params["query.".concat(key)] = query[key];
      });
      return "/api/".concat(lang, "/filter/programs?").concat(_queryString.default.stringify(params));
    },
    programsByCaseApiUrlTemplate: function programsByCaseApiUrlTemplate(lang, caseId, query) {
      var params = {};
      Object.keys(query).forEach(function (key) {
        return params["query.".concat(key)] = query[key];
      });
      return "/api/".concat(lang, "/filter/programs/").concat(caseId, "?").concat(_queryString.default.stringify(params));
    },
    productionlabelsApiUrlTemplate: function productionlabelsApiUrlTemplate(lang, query) {
      var params = {};
      Object.keys(query).forEach(function (key) {
        return params["query.".concat(key)] = query[key];
      });
      return "/api/".concat(lang, "/filter/productionlabels?").concat(_queryString.default.stringify(params));
    },
    productsApiUrlTemplate: function productsApiUrlTemplate(lang, query) {
      var params = {};
      Object.keys(query).forEach(function (key) {
        return params["query.".concat(key)] = query[key];
      });
      return "/api/".concat(lang, "/filter/products?").concat(_queryString.default.stringify(params));
    },
    rubricsApiUrlTemplate: function rubricsApiUrlTemplate(lang) {
      return "/api/".concat(lang, "/rubrics");
    },
    vacationsApiUrlTemplate: function vacationsApiUrlTemplate(lang, query) {
      var params = {};
      Object.keys(query).forEach(function (key) {
        return params["query.".concat(key)] = query[key];
      });
      return "/api/".concat(lang, "/filter/vacation?").concat(_queryString.default.stringify(params));
    }
  },
  search: {
    itemsPerPage: 24
  }
};
var metaPageDomain = document.querySelector('meta[name="page-domain"]');
cfg.pageDomain = '';

if (metaPageDomain) {
  cfg.pageDomain = metaPageDomain.content;
}

var googleMapData = {
  url: 'https://maps.googleapis.com/maps/api/js',
  vars: {
    v: '3.exp',
    libraries: 'geometry,drawing,places'
  }
};
cfg.projectKeys = {
  vomhof: 'vomhof',
  alaferme: 'vomhof',
  dallacampagna: 'vomhof',
  fromthefarm: 'vomhof',
  brunch: 'brunch',
  lgw: 'lgw',
  schule: 'schub',
  ecole: 'schub',
  scuola: 'schub',
  stallvisite: 'stallvisite',
  visitesetables: 'stallvisite',
  visitastalle: 'stallvisite',
  stablevisit: 'stallvisite',
  lockpfosten: 'lockpfosten',
  infosurlechamp: 'lockpfosten',
  paliindicatori: 'lockpfosten',
  whiteinformationposts: 'lockpfosten'
};
cfg.priorities = [{
  name: 'vomhof',
  priority: 1
}, {
  name: 'brunch',
  priority: 2
}, {
  name: 'stallvisite',
  priority: 4
}, {
  name: 'schub',
  priority: 5
}, {
  name: 'lockpfosten',
  priority: 6
}];
cfg.projectKeysWithCities = ['brunch', 'schub', 'toh', 'stallvisite'];
var keyElement = document.getElementById('google-maps-key');

if (keyElement.getAttribute('data-key')) {
  googleMapData.vars.key = keyElement.getAttribute('data-key');
}

cfg.googleMapURL = googleMapData.url + '?' + Object.keys(googleMapData.vars).map(function (key) {
  return key + '=' + googleMapData.vars[key];
}).join('&');
var _default = cfg;
exports.default = _default;
var api = cfg.api,
    googleMapURL = cfg.googleMapURL,
    search = cfg.search,
    projectKeys = cfg.projectKeys,
    pageDomain = cfg.pageDomain;
exports.pageDomain = pageDomain;
exports.projectKeys = projectKeys;
exports.search = search;
exports.googleMapURL = googleMapURL;
exports.api = api;


//////////////////
// WEBPACK FOOTER
// ./client/conf.js
// module id = 76
// module chunks = 0